import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { useUserContext } from '../context/UserContext';

const Freinds = ({ userId, usrAuth, AlterRequest }) => {

    const { GetFreindsRequests, freinds, request, mySentRequests, fetchMyPendingRequests } = useUserContext();
    useEffect(() => {
        GetFreindsRequests(userId, 1);
        GetFreindsRequests(userId, 2);
    }, [userId, usrAuth]);

    const handleAcceptReject = (e, type, id) => {
        AlterRequest(e, type, id);
        setTimeout(() => {
            GetFreindsRequests(userId, 1);
            GetFreindsRequests(userId, 2);
            fetchMyPendingRequests();
        }, 500);
    };

    return (
        <div className="personal_right_box">
            <ul className="nav nav-pills pb-0" id="pills-tab" role="tablist">
                <li className="nav-item" role="presentation">
                    <button className="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Friendships</button>
                </li>
                {usrAuth &&
                    <li className="nav-item" role="presentation">
                        <button className="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">
                            Requests
                            {request?.filter(r => r.data.user_id_two == userId).length > 0 && (
                                <span style={{ background: '#ff4444', color: '#fff', borderRadius: '99px', fontSize: '11px', padding: '1px 6px', fontWeight: 'bold', marginLeft: '5px' }}>
                                    {request.filter(r => r.data.user_id_two == userId).length}
                                </span>
                            )}
                        </button>
                    </li>}
                {usrAuth &&
                    <li className="nav-item" role="presentation">
                        <button className="nav-link" id="pills-sent-tab" data-bs-toggle="pill" data-bs-target="#pills-sent" type="button" role="tab" aria-controls="pills-sent" aria-selected="false">
                            Pending
                            {mySentRequests?.length > 0 && (
                                <span style={{ background: '#f0a500', color: '#fff', borderRadius: '99px', fontSize: '11px', padding: '1px 6px', fontWeight: 'bold', marginLeft: '5px' }}>
                                    {mySentRequests.length}
                                </span>
                            )}
                        </button>
                    </li>}
            </ul>
            <div className="tab-content" id="pills-tabContent">

                {/* Friendships Tab */}
                <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                    <div className='row'>
                        {freinds?.length ? freinds.map((mem) => {
                            return <div key={mem.user_data.id} className="col-lg-4 col-md-4 col-12">
                                <div className="search-groups-boxs">
                                    <div className="search-groups-box-back" style={{ backgroundImage: `url(https://buzzinguniverse.com/backend/${mem.user_data.cover_photo}), radial-gradient(circle, rgb(153 153 153) 0%, rgba(0, 0, 0, 0.15) 58%, rgba(0, 0, 0, 0.3) 100%)` }} />
                                    <span><img src={mem.user_data.photo ? `https://buzzinguniverse.com/backend/${mem.user_data.photo}` : '/images/default.png'} alt="img" /></span>
                                    <h2><Link to={`/member/${mem.user_data.id}/profile`}>{mem.user_data.first_name} {mem.user_data.last_name}</Link></h2>
                                    <strong>Active 7 hours, 27 minutes ago</strong>
                                    <div className="friend_line">
                                        <ul>
                                            <li>
                                                <h4>{mem.friend_count}</h4>
                                                <strong>Friends</strong>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="search-groups-btn">
                                        <Link to={`/member/${mem.user_data.id}/profile`}>View Profile</Link>
                                    </div>
                                </div>
                            </div>
                        }) : <div className='notfound'>No Friends Found</div>}
                    </div>
                </div>

                {/* Received Requests Tab */}
                {usrAuth && <div className="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                    <div className='row'>
                        {request?.filter(r => r.data.user_id_two == userId).length ? request.filter(r => r.data.user_id_two == userId).map((mem) => {
                            return <div key={mem.data.id} className="col-lg-4 col-md-4 col-12">
                                <div className="search-groups-boxs">
                                    <div className="search-groups-box-back" style={{ backgroundImage: `url(${mem.user_data.cover_photo}), radial-gradient(circle, rgb(153 153 153) 0%, rgba(0, 0, 0, 0.15) 58%, rgba(0, 0, 0, 0.3) 100%)` }} />
                                    <span><img src={mem.user_data.photo ? `https://buzzinguniverse.com/backend/${mem.user_data.photo}` : '/images/default.png'} alt="img" /></span>
                                    <h2><Link to={`/member/${mem.user_data.id}/profile`}>{mem.user_data.first_name} {mem.user_data.last_name}</Link></h2>
                                    <strong>Active 7 hours, 27 minutes ago</strong>
                                    <div className="friend_line">
                                        <ul>
                                            <li>
                                                <h4>{mem.friend_count}</h4>
                                                <strong>Friends</strong>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="search-groups-btn">
                                        <button onClick={(e) => handleAcceptReject(e, 2, mem.data.id)}>Accept</button>
                                        <button onClick={(e) => handleAcceptReject(e, 3, mem.data.id)}>Reject</button>
                                    </div>
                                </div>
                            </div>
                        }) : <div className='notfound'>No Requests Found</div>}
                    </div>
                </div>}

                {/* Sent (Pending) Requests Tab */}
                {usrAuth && <div className="tab-pane fade" id="pills-sent" role="tabpanel" aria-labelledby="pills-sent-tab">
                    <div className='row'>
                        {mySentRequests?.length ? mySentRequests.map((mem) => {
                            return <div key={mem.data.id} className="col-lg-4 col-md-4 col-12">
                                <div className="search-groups-boxs">
                                    <div className="search-groups-box-back" style={{ backgroundImage: `url(https://buzzinguniverse.com/backend/${mem.user_data.cover_photo}), radial-gradient(circle, rgb(153 153 153) 0%, rgba(0, 0, 0, 0.15) 58%, rgba(0, 0, 0, 0.3) 100%)` }} />
                                    <span><img src={mem.user_data.photo ? `https://buzzinguniverse.com/backend/${mem.user_data.photo}` : '/images/default.png'} alt="img" /></span>
                                    <h2><Link to={`/member/${mem.user_data.id}/profile`}>{mem.user_data.first_name} {mem.user_data.last_name}</Link></h2>
                                    <strong>Request Pending</strong>
                                    <div className="friend_line">
                                        <ul>
                                            <li>
                                                <h4>{mem.friend_count}</h4>
                                                <strong>Friends</strong>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="search-groups-btn">
                                        <button onClick={(e) => handleAcceptReject(e, 3, mem.data.id)}>Cancel Request</button>
                                    </div>
                                </div>
                            </div>
                        }) : <div className='notfound'>No Pending Requests</div>}
                    </div>
                </div>}

            </div>
        </div>
    )
}

export default Freinds
